import React from "react";

export default function Now() {
  return <div>Now</div>;
}
